<script setup lang="ts">
const props = defineProps({
  placeholder: {type: String, default: ''},
  type: {type: String, default: 'text'},
  mask: {type: String, default: ''},
  readonly: {type: Boolean, default: false},
  id: {type: String, default: ''},
  inputMode: {type: String, default: ''},
  required: {
    type: Boolean,
    default: false
  },
})
const clicked = ref(false)

function handleClick() {
  clicked.value = true
}

function handleBlur() {
  clicked.value = false
}

const model = defineModel()
</script>

<template>
  <div class="rounded-2xl border border-secondary-500 relative h-[44px]">
    <p
        class="ml-4 absolute text-gray-600 pointer-events-none  transition-all duration-100 ease-in-out"
        :class="(model || clicked) ? 'top-1 text-xs' : 'top-1/2 transform -translate-y-1/2 text-base' "
    >
      <span class="flex gap-2 items-center ">
      <span>
      {{ placeholder }}
        </span>
      <span v-if="required" class="error-text">*</span>
        </span>
    </p>

    <div
        class=" w-full overflow-hidden flex gap-2 items-center py-3 px-4">
      <slot name="icon"></slot>
      <ClientOnly>
        <input
            v-if="mask"
            :id="id"
            :type="type"
            :readonly="readonly"
            :inputmode="inputMode || undefined"
            v-mask="mask"
            v-model="model"
            @click="handleClick"
            @blur="handleBlur"
            class="bg-inherit text-inherit relative  placeholder:text-gray-400 outline-none w-full text-primary-blue-900 text-base-d font-normal"
            :class="(model || clicked) ? 'top-1.5' : 'top-1/2' "
        >
        <input
            v-else
            :id="id"
            :type="type"
            :readonly="readonly"
            :inputmode="inputMode || undefined"
            v-model="model"
            @click="handleClick"
            @blur="handleBlur"
            class="bg-inherit text-inherit relative  placeholder:text-gray-400 outline-none w-full text-primary-blue-900 text-base-d font-normal"
            :class="(model || clicked)? 'top-1.5 ' : 'top-1/2' "
        >
      </ClientOnly>
    </div>
  </div>
</template>